import { useFormContext, useController } from 'react-hook-form';
import { FormType } from '../../shared/models/form';
import { useTranslation } from 'react-i18next';

const PromoCode = () => {
  const { control } = useFormContext<FormType>();
  const { t } = useTranslation();
  const {
    field: { onChange, onBlur, value, ref, name },
  } = useController({ control, name: 'promoCode' });

  return (
    <div>
      <label className="text-sm mb-2 block px-2">{t('Promo Code')}</label>
      <input
        type="text"
        id={name}
        className="form-input w-full h-12 rounded bg-white border border-input-gray focus:ring-2 focus:ring-gray-500 focus:border-input-gray"
        onChange={onChange}
        onBlur={onBlur}
        value={value}
        ref={ref}
        name={name}
      />
    </div>
  );
};

export default PromoCode;
